import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string/index.js'
import {
  logUtil,
  pickObjectUtil,
  stringifyQueryParamsObjectUtil
} from 'packages/src'

const QUERY_PARAMS_TO_ALLOW = [
  'plan',
  'q',
  'option'
]

/**
 * @param url
 * @param {Location} location
 * @returns {*|string}
 */
export function getCanonicalUrlRouteUtil ({ url, location }) {
  const debugProps = {
    url,
    location
  }
  logUtil('getCanonicalUrlRouteUtil').debug('debugProps=', debugProps)

  if (url) {
    return url
  }

  const newUrl = location.origin + location.pathname
  const queryParams = pickObjectUtil(
    getQueryParamsFromStringObjectUtil(location.search),
    QUERY_PARAMS_TO_ALLOW
  )

  debugProps.queryParams = queryParams
  debugProps.newUrl = newUrl
  logUtil('getCanonicalUrlRouteUtil').debug('debugProps=', debugProps)

  if (!Object.keys(queryParams).length) {
    return newUrl
  }

  return newUrl + `?${stringifyQueryParamsObjectUtil(queryParams)}`
}
